export default {
  state: {
    types: []
  },
  mutations: {
    'GET_WORKORDER_TYPE' (state, data) {
      state.types = data
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/wo.js